import OrderListComponent from '../components/order-list/orderList'

const OrderList = () => <OrderListComponent />

export default OrderList;